import store from '~/store'

/**
 * Boot gate. Everything the first paint depends on is resolved here, before any
 * route component mounts.
 *
 * `mega_menu_enabled` decides which header TopMenu.vue renders, so it has to be
 * known before Header.vue mounts. Resolving it afterwards — which is what
 * Header.vue's own `mounted` hook does — painted the legacy header first and
 * then swapped it for the mega menu, which read as a flicker on every login and
 * page refresh. It rides along with the user fetch, so it costs no extra round
 * trip on the path that already waits for one.
 *
 * Failures leave `publicSettingsLoaded` false: the flags stay at their defaults
 * (legacy header) and the next navigation retries.
 */
export default async (to, from, next) => {
  const token = store.getters['auth/token']

  await Promise.all([
    !store.getters['auth/check'] && token
      ? store.dispatch('auth/fetchUser').catch(() => {})
      : null,
    token && !store.getters['settings/publicSettingsLoaded']
      ? store.dispatch('settings/fetchPublicSettings').catch(() => {})
      : null
  ])

  // With the flag on the strip renders from the menu payload, so fetching it
  // here rather than in DynamicTopMenu's `created` hook stops the nav from
  // painting empty and then filling in. The action is guarded on its own
  // `publicLoaded`, so once it has loaded this is one request per session, not
  // per navigation; a failed load is retried on the next one.
  if (store.getters['settings/megaMenuEnabled']) {
    await store.dispatch('mega-menu/fetchPublicMenu')
  }

  next()
}
